import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

/**
 * Adds a red asterisk after a mandatory field's label
 */
@Directive({
  selector: '[rxMandatory]',
})
export class MandatoryDirective implements AfterViewInit {
  @Input() rxMandatory = '';

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    if (!this.rxMandatory || this.rxMandatory === 'true') {
      const label: HTMLElement = this.el.nativeElement.querySelector('label');

      this.addAsterisk(label.querySelector('span') ?? label);
    }
  }

  private addAsterisk(htmlElement: HTMLElement): void {
    htmlElement.insertAdjacentHTML('beforeend', '<span class="ml-1 color-red">*</span>');
  }
}
